export default __webpack_public_path__ + "static/media/delivery-icon.c45bead4.svg";